export const RecoveryEmailPopupFormAlert = {
  EMPTY: { rus: 'Пожалуйста, введите почту', ua: `Будь ласка, введіть пошту`},
  MISTAKE: { rus: 'В адресе ошибка', ua: `В адресі помилка`},
  NO_USER_FOUND: { rus: 'Нет пользователя с такой почтой', ua: `Немає користувача з такою поштою`},
  SERVER_ERROR: { rus: 'Ошибка на сервере, попробуйте еще раз', ua: `Помилка на сервері, спробуйте ще раз`},
}
